import CreatorDeletePaymentMethodModal from "./CreatorDeletePaymentMethodModal";

export default CreatorDeletePaymentMethodModal;
